import React, { Component } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { connect } from 'react-redux'
import { Button, FormControl, ControlLabel, Row, Col } from 'react-bootstrap'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

import DuplicateMetadataModal from './DuplicateMetadataModal'

class AddMetadataType extends Component {

  state = {
    newMetadataName: '',
    newMetadataType: '',
    newMetadataAlreadyExists: false,
    metadataThatAlreadyExists: null,
    newMetadataIsExactDuplicate: false,
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })


  listOfMetadataTypes = () => {
    const metadata = this.props.metadata.sort((a, b) => a.name.localeCompare(b.name))
    return (
      <ul>
        {metadata.map(meta => {
          return (
            <Col md={6} key={meta.id}>
              <li>
                {meta.name}
              </li>
            </Col>
          )
        })}
      </ul>
    )
  }

  checkIfMetadataExists = () => {
    if (!this.state.newMetadataName || !this.state.newMetadataType) {
      return swal({
        title: "Error",
        text: "Please enter a name and select a type before saving",
        icon: "error",
        button: "Continue",
      })
    }

    const exactMatchingMetadata = this.props.metadata.find(meta => {
      return meta.name.toLowerCase() === this.state.newMetadataName.toLowerCase()
    })

    if (exactMatchingMetadata) {
      return this.setState({
        newMetadataAlreadyExists: true,
        metadataThatAlreadyExists: exactMatchingMetadata,
        newMetadataIsExactDuplicate: true,
      })
    }

    const matchingMetadata = this.props.metadata.find(meta => {
      return meta.name.toLowerCase().includes(this.state.newMetadataName.toLowerCase()) ||
      this.state.newMetadataName.toLowerCase().includes(meta.name.toLowerCase())
    })

    if (matchingMetadata) {
      return this.setState({
        newMetadataAlreadyExists: true,
        metadataThatAlreadyExists: matchingMetadata,
        newMetadataIsExactDuplicate: false,
      })
    }

    return this.handleSubmit()
  }


 handleCancelSubmit = () => {
   return this.setState({
      newMetadataAlreadyExists: false,
      metadataThatAlreadyExists: null,
      newMetadataIsExactDuplicate: false,
      newMetadataName: '',
      newMetadataType: '',
    })
  }


  handleSubmit = () => {
    if (this.state.newMetadataName && this.state.newMetadataType) {

      swal({
        text: "Saving metadata... Please stand by.",
        icon: require("../../../static/images/spinner.gif"),
        button: false
      })


      this.setState({
        newMetadataAlreadyExists: false,
        metadataThatAlreadyExists: null,
        newMetadataIsExactDuplicate: false,
      })

      axios({
        method: "POST",
        url: `${getServerURL()}${this.props.route}/`,
        headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
        data: {
          created_by: this.props.user,
          name: this.state.newMetadataName,
          type: this.state.newMetadataType,
          client: this.props.selectedClient.url,
        }
      })
      .then(response => {
        this.props.addMetadata(response.data)
        swal({
          title: "Success",
          text: "The metadata type " + this.state.newMetadataName + " has been created",
          icon: "success",
          button: "Continue",
        })
        this.setState({ newMetadataName: "", newMetadataType: ""  })
      })
      .catch(error => {
        const message = "There was an error in creating your metadata type"
        handleErrorFetchingData(error, message)
      })
    } else {
      return swal({
        title: "Error",
        text: "Please enter a metadata type before saving",
        icon: "error",
        button: "Continue",
      })
    }
  }

  getValuesForModal = () => {
    const { metadataThatAlreadyExists } = this.state

    if (!metadataThatAlreadyExists) {
      return []
    }

    if (metadataThatAlreadyExists && metadataThatAlreadyExists.metadata_values) {
      return metadataThatAlreadyExists.metadata_values
    }

    if (metadataThatAlreadyExists && metadataThatAlreadyExists.proposal_metadata_values) {
      return metadataThatAlreadyExists.proposal_metadata_values
    }
  }

  render() {
    const { selectedClient, selectedModel, metadata } = this.props
    const { newMetadataAlreadyExists, metadataThatAlreadyExists, newMetadataIsExactDuplicate } = this.state

    return (
      <div id="AddMetadataType">

        {newMetadataAlreadyExists ?
          <DuplicateMetadataModal
            show={newMetadataAlreadyExists}
            name={metadataThatAlreadyExists ? metadataThatAlreadyExists.name : ""}
            type={metadataThatAlreadyExists ? metadataThatAlreadyExists.type : ""}
            values={this.getValuesForModal()}
            isExactDuplicate={newMetadataIsExactDuplicate}
            typeOrValue={"type"}
            projectOrProposal={selectedModel}
            client={selectedClient}
            handleSubmit={this.handleSubmit}
            handleCancelSubmit={this.handleCancelSubmit}
          />
          :
          null
        }

        <Row>
          <Col md={6}>
            <ControlLabel>Name</ControlLabel>
            <FormControl
              type="text"
              value={this.state.newMetadataName}
              placeholder='Enter name for new metadata...'
              name='newMetadataName'
              onChange={this.handleChange}
            />
          </Col>

          <Col md={6}>
            <ControlLabel>Type</ControlLabel>
            <FormControl
              componentClass="select"
              name='newMetadataType'
              value={this.state.newMetadataType}
              onChange={this.handleChange}
            >
              <option value="">-</option>
              <option value="Date">Date</option>
              <option value="Number">Number</option>
              <option value="Selectable Options">Selectable Options</option>
              <option value="Text">Text</option>
              <option value="User">User</option>
            </FormControl>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col xs={6}>
            <Button onClick={this.checkIfMetadataExists} bsStyle="primary">
              Submit
            </Button>
          </Col>
        </Row>

        <br/>

        <Row>
          <Col xs={12}>
            {metadata.length > 0 ?
              <span>
                List of {selectedClient.name} {selectedClient.short_code} {selectedModel.toLowerCase()} metadata that already exist
                {this.listOfMetadataTypes()}
              </span>
              :
              <span>
                No {selectedClient.name} {selectedClient.short_code} {selectedModel.toLowerCase()} metadata types exist in the database
              </span>
            }
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.manageLogin.user
  }
}

export default connect(mapStateToProps)(AddMetadataType)



// WEBPACK FOOTER //
// ./src/routes/manager/components/AddMetadataType.js